import * as React from 'react';

import BoxNotes16 from './BoxNotes16';

export const boxNotes16 = () => <BoxNotes16 />;

export default {
    title: 'Icon|Fill|BoxNotes16',
    component: BoxNotes16,
    parameters: {
        notes: "`import BoxNotes16 from 'box-ui-elements/es/icon/fill/BoxNotes16';`",
    },
};
